<template>
  <div class="ol-input">

    <input
      v-model="localText"
      :placeholder="placeholder"
      :id="id"
      :name="name"
      :class="'ol-input__text' + (hasError ? '_error' : '')"
      type="text"
      :style="inputStyle"
    >

    <template v-if="hasMsg && showErrorMsg">
      <span
        :class="'ol-input__msg_' + (hasError ? 'error' : 'success')"
      >{{msg}}</span>
    </template>

  </div>
</template>

<script>
	export default {
		name: "InputText",
		props: {
			value: {
				type: String,
				default: ''
			},
			id: {
				type: String,
				default: ''
			},
			name: {
				type: String,
				default: ''
			},
			isRequired: {
				type: Boolean,
				default: false
			},
			showErrorMsg: {
				type: Boolean,
				default: false
			},
			placeholder: {
				type: String,
				default: ''
			},
			inputStyle: {
				type: String,
				default: ''
			}

		},
		data() {
			return {
				localText: '',
				msg: '',
				hasError: false
			}
		},
		methods: {
			updateText() {
				this.localText = this.value;
			},

			update() {
				this.$emit('input', this.localText);
				this.$emit('error', this.hasError);
			}
		},
		computed: {
			hasMsg() {
				return (this.msg.length);
			}
		},
		watch: {
			value(){
				this.updateText();
      },
			localText() {
				if (this.isRequired && this.localText === '') {
					this.hasError = true;
					this.msg = 'Обязательное поле';
				} else {
					this.hasError = false;
					this.msg = '';
				}

				this.update();
			}
		},
    mounted() {
	    this.updateText();
    }
	}
</script>

<style scoped lang="scss">
  @mixin inputText() {
    min-width: 50px;
    height: 16px;
    padding: 6px 12px;
    border: 1px solid #CBCBCB;
    background: #fff;
    border-radius: 2px;
  }

  @mixin msg() {
    position: relative;
    display: block;
    border-radius: 2px;
    padding: 4px 10px;
  }

  @mixin success() {
    color: #1bff61;
  }

  @mixin error() {
    color: #f00;
  }

  .ol-input {
    display: block;
    position: relative;

    &__text {
      @include inputText;

      &_error {
        @include inputText;
        border: 1px solid #f00;
        background: rgba(255, 0, 0, 0.24);
        color: #f00;
      }
    }

    &__msg {

      &_success {
        @include msg;
        @include error;
      }

      &_error {
        @include msg;
        @include error;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/Components/InputText.vue